/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const attorneySectionHeadingsStyle = {
  header: {
    marginBottom: "30px",
    textAlign: "center",
  },
};

export default attorneySectionHeadingsStyle;
